/** @jsxImportSource react */
import Script from 'next/script';

import './naverWcsWindow';
import { NAVER_WCS_ACCOUNT_ID } from './types';

/**
 * 네이버 전환 스크립트의 공통 블록(T1) — 사이트식별자 설정 + 쿠키 도메인 + PV 전송.
 *
 * 신버전(wcs.trans)에서는 T1이 전환 블록(T2)보다 먼저 실행되어야 하며, `wcs_do()`는 인자를 받지 않는다.
 * 구버전(cnv)의 `wcs_do(_nasa)`처럼 전환값을 실어 보내지 않고, 전환은 `wcs.trans`가 따로 전송한다.
 *
 * @see https://naver.github.io/conversion-tracking/pages/05_cnv_to_trans_guide/
 */
export function NaverWCS() {
  return (
    <Script
      id="naver-wcs"
      src="https://wcs.naver.net/wcslog.js"
      strategy="afterInteractive"
      onLoad={() => {
        if (!window.wcs_add) {
          window.wcs_add = {};
        }

        window.wcs_add.wa = NAVER_WCS_ACCOUNT_ID;

        if (window.wcs) {
          window.wcs.inflow('myrealtrip.com');
          window.wcs_do();
        }
      }}
    />
  );
}
